import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "root",
  class: "popup"
}
const _hoisted_2 = { class: "popup__box" }
const _hoisted_3 = { class: "popup__inner-box" }
const _hoisted_4 = { class: "iscroll-wrapper" }
const _hoisted_5 = { class: "iscroll__scroller" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "popup__close",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.tapClose && _ctx.tapClose(...args)), ["prevent"]))
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ])
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "nonScroll" }, null, -1))
  ], 512))
}